import { SortKey } from "../components/SortSelect/SortSelect";
import { FinanceOverviewItem } from "../types/FinanceOverviewItem";
import { ProjectCheck } from "../types/ProjectCheck";

export function dynamicSort<
  T extends Pick<
    ProjectCheck | FinanceOverviewItem,
    "clientName" | "projectNumber" | "projectTitle"
  >,
>(list: T[], sortBy: SortKey, thenBy: SortKey | null): T[] {
  var result = list;
  return result.sort((a, b) => {
    const primary = a[sortBy].localeCompare(b[sortBy]);
    if (primary !== 0 || thenBy === null) return primary;
    return a[thenBy].localeCompare(b[thenBy]);
  });
}
